import { MemberInterface } from './MemberInterface';

export const memberContents: MemberInterface[] = [
  {
    img: './image/story/story3.png',
    header: '기획자로서의 첫 발걸음',
    content: '기획자로서의 첫 발걸음을 내딛을 수 있는 소중한 경험이었습니다. 내가 기획자를 할 수 있을까? 기획이라는 직무는 어떤걸까? 하는 막연한 생각들이 뎁스 활동을 통해 구체화 되었고, 제 진로에 대한 확신을 가지게 된 계기가 되었습니다. 진로에 대한 애정을 가지고 열심히 나아가는 사람들과 함께 프로젝트를 진행한다는 것은 정말 큰 행운이에요 ! 뎁스 1기 고생 많았고, 앞으로의 뎁스도 응원합니다',
    name: '이여원',
    department: 'Product Manager',
    isLeft: true,
    cohort: '1기',
  },
  {
    img: './image/story/story2.png',
    header: '협업 경험의 중요성을 깨닫다',
    content: 'pm, 디자이너, 프론트, 백엔드 각 파트를 나눠 진행한 제대로된 첫 협업 프로젝트였습니다. 처음엔 개발 혼자 하는거랑 다를게 있겠냐고 생각했지만, 여기저기서 왜 협업 경험을 중요하게 여기는지 몸소 체험할 수 있었습니다. 개발 역량에 대해서도 또 인간적으로도 많이 성장할 수 있는 계기가 된 뎁스 였습니다. 많이 배우고 좋은 사람도 많이 만날 수 있게 해준 뎁스와 모든 팀원들에게 1년 동안 모두 수고 많았고 고맙다고 말하고 싶네요. 뎁스에서의 경험과 배운 것들을 바탕으로 더욱 성장하고 발전할 수 있는 계기가 되었으면 좋겠습니다. 그럼 다시 만나는 그날까지 안녕~~ thank you',
    name: '김해찬',
    department: 'Backend Developer',
    isLeft: false,
    cohort: '1기',
  },
  {
    img: './image/story/storyKa.png',
    header: '개발 스터디를 통해 성장한 나',
    content: 'DEPth 1기에 프론트엔드 개발자로 참여하면서 즐거운 추억과 값진 경험을 얻을 수 있었습니다! 다양한 직군의 팀원들과의 협업을 통해 협업 및 커뮤니케이션 능력을 향상시킬 수 있었고, 개발 스터디를 하면서 많은 것을 배우고 함께 성장할 수 있는 좋은 기회를 얻을 수 있었습니다. 소중한 경험을 할 수 있게 만들어주셔서 감사합니다!',
    name: '이가은',
    department: 'FrontEnd Developer',
    isLeft: true,
    cohort: '1기',
  },
  {
    img: './image/story/story4.png',
    header: '미래를 위한 원동력이 된 1년',
    content: 'DEPth 1기 기획부원 문규원으로 참여한 1년은 제게 앞으로 미래를 위해 열심히 살 수 있던 원동력이 되었던 한 해였습니다. 전공관련 취업에 대해 막연한 생각만 들었던 때에 배운 전공지식을 활용하여 분석하고 직접 서비스를 기획함으로써 유의미한 학교 생활을 보냈다는 생각이듭니다. 특히, 나와 다른 분야의 사람들과 협업을 통해 하나의 결과물을 만들어내는 과정에서 많은 경험을 통해 한단계 성장한 저를 만날 수 있었습니다. 앞으로의 DEPth와 함께 더더욱 꾸준한 성장을 이뤄나가고싶습니다 ! 뎁쓰 모두 고생했어요 : )',
    name: '문규원',
    department: 'Product Manager',
    isLeft: false,
    cohort: '1기',
  },
  {
    img: './image/story/story5.png',
    header: '열정으로 불태웠던 뎁스',
    content: '저는 1기 기획부로 참여했습니다. 기획뿐만 아니라 경영에 대한 배경지식이 없었음에도 불구하고 무언가를 해 보자라는 마음 하나만으로 신청하였습니다. 활동을 하면서 개인의 역량도 물론 중요하지만 팀으로 협업하는 것이기 때문에 협동력 또한 중요하다는 것을 느낄 수 있었습니다. 프로젝트를 통해 협동력을 배웠습니다. 그리고, 뎁스 내에서 이루어지는 스터디를 통해 개인의 역량을 키울 수 있는 기회가 있습니다. 이처럼 열정 하나만 있다면 성장하는 자신의 모습을 볼 수 있을 겁니다!',
    name: '김보은',
    department: 'Product Manager',
    isLeft: true,
    cohort: '1기',
  },
  {
    img: './image/story/story6.png',
    header: '프로젝트 성공의 키, 협업',
    content: '협업은 프로젝트의 성공에 매우 중요한 역할을 한다고 깨달았습니다. 또한, 뎁스에서 기획자로 일하며 기획 프로세스를 함께 경험하고 고민하며, 기획의 역할이 얼마나 중요한지 깨달았으며 디자인과 개발에 대한 지식도 함께 알아가는 등 좋은 경험을 많이 할 수 있었습니다. 무엇보다 뎁스 부원들 모두가 한 마음으로 열심히 참여했기에 프로젝트의 성공을 이끌어낼 수 있었다고 생각합니다.',
    name: '박상민',
    department: 'Product Manager',
    isLeft: false,
    cohort: '1기',
  },
  {
    img: './image/story/story7.png',
    header: '놀라지 않을 수 없었다',
    content: "뎁스1기에 가입했을때만 하더라도 웹 프로그래밍의 알파벳인 HTML조차 익숙하지 않았다. 하지만 뛰어난 실력의 팀 리더 상원이를 비룻해 다양한 경험을 가진 개발자분들과 함께한 스터디를 통해 빠르게 성장할 수 있었다. 물론 그 과정에서 피나는 노력이 있었지만, HTML 작성도 힘겨워 했던 내가 어느새 리액트로 '옛술의 전당' 마이페이지를 만들고 있다는 사실에 놀라지 않을 수 없었다",
    name: '김희윤',
    department: 'FrontEnd Developer',
    isLeft: true,
    cohort: '1기',
  },
  {
    img: './image/story/story8.png',
    header: '경험의 중요성을 알게 된 1년',
    content: 'DEPth 2기 기획파트원으로 참여해 스터디, MVP project와 main project까지 진행하며 많은 것을 배웠습니다. 스터디에서 배운 것으로 프로젝트드를 기획할 수 있었고 좋은 팀원들을 만나 즐겁게 2기 활동을 마무리 할 수 있었습니다. 프로젝트를 기획하고 배포, 그리고 유지보수까지 하는 경험을 DEPth에서 하며 개인 역량을 늘리는 것은 물론이고 디자인과 개발에 대해서도 조금씩 알아가며 성장할 수 있었고 사람으로서 배운 것도 많았던 것 같습니다. DEPth 2기에 지원한 일이 2023년에 한 일 중 가장 잘한 일이라고 생각할정도로 저에게는 매우 소중하고 중요한 1년이었습니다! DEPth 짱',
    name: '조민경',
    department: 'Product Manager',
    isLeft: false,
    cohort: '2기',
  },
  {
    img: './image/story/story9.png',
    header: '더 넓게 확장된 시야',
    content: '뎁스 2기 디자인 파트로 참여하며 뼈가 되고 살이 되는 많은 것들을 배운 것 같습니다. 배운 것들을 바로 mvp프로젝트와 메인 프로젝트에서 다뤄보면서 실력을 그치지 않고 키워갈 수 있었습니다. 프로젝트를 통해서 디자인 뿐 아니라 개발팀, 기획팀과 함께 하면서 협업의 중요성에 대해서도 더욱 깨닫게 되었습니다. 뎁스를 통해 서비스를 바라보는 시야가 넓어질 수 있었던 것 같습니다. nice~chu~',
    name: '김민주',
    department: 'Designer',
    isLeft: true,
    cohort: '2기',
  },
  {
    img: './image/story/story3rdPlan.png',
    header: '몰입하고 성장한 경험',
    content: 'DEPth 3기에 백엔드 개발자로 잠여하며 스터디부터 프로젝트까지 모두 경험하며 1년을 보냈습니다. 무언가라도 해보자라는 마음으로 시작한 동아리 활동에서 밤을 새워가며 공부하고 함께 서비스를 만들어가며 정말 값진 경험을 했습니다. 협업의 중요성을 깨닫고 개발자 뿐만 아니라 한 사람으로서도 성장할 수 있는 계기가 되었던 것 같습니다. 좋은 분들과 함께 1년을 보낼 수 있어서 행운이라고 생각하고 모든 팀원들에게 고생했다고 말하고 싶습니다. 매우 소중한 1년이였습니다! 모두 감사합니다!',
    name: '주도현',
    department: 'Backend Developer',
    isLeft: true,
    cohort: '3기',
  },
  {
    img: './image/story/story3rdFront.png',
    header: '뎁스와 함께한 협업과 도전의 기록',
    content: '무작정 아는 게 없어서, 잘해보고 싶어서 들어온 뎁스라는 동아리에서 많은 걸 배우기도 했지만 함께 알아가는 즐거움이 크게 다가왔습니다. 뎁스에 들어오기 전 도전을 두려워하고 협업의 중요성을 모르던 저는 어느샌가 다양한 사람들과 함께하며 도전하는 걸 즐기는 사람이 되었습니다. 또한 대학 수업에서는 배우지 않는 체계적인 협업 경험을 할 수 있어서 정말 감사한 기회였다고 생각합니다. 저처럼 많은 학우분들이 뎁스에 들어와 도전을 즐기셨으면 좋겠습니다. 감사합니다!!',
    name: '김소연',
    department: 'FrontEnd Developer',
    isLeft: false,
    cohort: '3기',
  },
  {
    img: './image/story/story3rdAndroid.png',
    header: '함께하는 도전의 기록',
    content: '올해 처음으로 안드로이드를 접하게 됐고 그와 동시에 첫 동아리인 DEPth에서 안드로이드 파트를 맡게 되었는데, 몇 번의 경험이 있던 타 동아리원에 비해 나의 실력이 부족함을 느꼈지만 그런 나를 잘 이끌어준 팀원들에게 감사함을 느꼈고 그들을 부지런히 따라가야겠다고 다짐했다. 이번 방학을 통해서도 스터디를 통해 부족한 부분을 채우고 능숙히 안드로이드를 다룰 때까지 공부할 것이다!',
    name: '익명',
    department: 'Android Developer',
    isLeft: true,
    cohort: '3기',
  },
  {
    img: './image/story/story3rdPlan.png',
    header: '꿈에 한 발 더 가까워지다',
    content: '뎁스 기획 스터디를 통해 서비스 기획에 대한 세부사항을 배울 수 있게 되어서 너무 기뻤습니다 특히 다른 파트와 협업을 하게 될 시에 필요했던 와이어프레임 설계와 화면 설계서를 작성할 때 많이 배우게 되었던 것 같습니다. 저는 PM 진로를 희망하고 있는데, 진로에 한발자국 가까워진 것 같아서 기뻤습니다!',
    name: '익명',
    department: 'Product Manager',
    isLeft: false,
    cohort: '3기',
  },
  {
    img: './image/story/story3rdDesign.png',
    header: '몰입 경험을 통한 효율성 향상',
    content: '스터디를 통해 작은 원자 디자인부터 함 페이지를 디자인에 이르기까지 디자인 시스템의 전체적인 구조와 원리를 배우고 이해할 수 있었다. 이렇게 디자인 시스템의 전체적인 구조를 이해하니 디자인 작업에서의 일관성과 효율성이 크게 향상된 것을 느꼈고, 팀원들과 과제를 공유하며 서로 다른 디자인 관점과 피드백을 통해 넓은 시각을 갖게 되었다.',
    name: '익명',
    department: 'Designer',
    isLeft: true,
    cohort: '3기',
  },
  {
    img: './image/story/story4thDesign.jpg',
    header: '깊이 있는 학습',
    content: '기존에 알고 있던 내용을 다시 한 번 정리하고 더 깊이 있게 이해할 수 있는 시간이었다. 파트원들의 과제를 공유하며 같은 주제를 다른 시각으로 볼 수 있다는 점이 좋았다. 스터디를 계기로 시야를 확장하고 성장할 수 있었다. 앞으로의 디자인 작업에도 이번 경험이 오래도록 도움이 될 것 같다.',
    name: '익명',
    department: 'Designer',
    isLeft: true,
    cohort: '4기',
  },
  {
    img: './image/story/story4thPlan.png',
    header: '다양한 관점을 배우다',
    content: '이번 스터디를 통해 다른 분들의 아이디어를 보며 다양한 관점을 확인할 수 있었고, 기초부터 배우며 부족한 부분을 채워갈 수 있었습니다. 물론 다른 분들과 다르게 이미 기획 경험이 있는 상황이었어서 여러 작업물을 보며 좀 더 배워가고 싶었는데 아쉬움이 남는 것 같습니다. 하지만 사전에 기획 심화 스터디를 하는 것에 대해 제안해주셨음에도 저의 선택으로 기초 스터디를 참여한 것이라 아쉬움보단 만족감이 더 큰 것 같습니다.',
    name: '익명',
    department: 'Product Manager',
    isLeft: false,
    cohort: '4기',
  },
  {
    img: './image/story/story4thAndroid.png',
    header: '앞으로 되고 싶은 개발자에 대해 생각해보다',
    content: '학기중에 스터디를 병행해야하다 보니 다소 촉박한 일정을 맞추기 위해 충분한 공부를 안한채 과제 일정에 맞추다 보니 다소 AI에 의존하며 진행해서, 실력향상을 스스로 막았다는 점이 아쉬웠지만, 그래도 촉박한 일정에 맞춰 AI로 코드를 작성하고, 또 코드 회고도 하면서, 단순 공부식으로만 진행하는게 아닌 능동적으로 프로젝트를 진행하는 방식에서 앞으로 "개발자"라는 직업을 위해 어떻게 공부를 하면서 만들고 싶은걸 만들것인지에 대한 갈피를 배운 것 같습니다.',
    name: '익명',
    department: 'Android Developer',
    isLeft: true,
    cohort: '4기',
  },
  {
    img: './image/story/story4thFront.png',
    header: '더 깊이 있는 지식을 얻을 수 있었던 시간',
    content: '뎁스의 웹 스터디를 하면서 좋은 분들과 함께 성장해나갈 수 있어서 좋은 기회였다고 생각합니다.javascript를 써보기만 했지 작동 방식과 원리에 대해서는 생각해 본 적이 없는데 스터디를 통해 javascript를 처음부터 차근차근 이해하고 정리해나가며 문제 풀이로 마무리함으로써 더욱 깊이 있는 지식을 얻을 수 있었습니다.스터디 기간이 더 길었으면 좋겠다고 느껴질만큼 의미있었고 기회가 된다면 다음에 또 참여하고 싶습니다.',
    name: '익명',
    department: 'FrontEnd Developer',
    isLeft: false,
    cohort: '4기',
  },
  {
    img: './image/story/story4thServer.png',
    header: '잠재 능력을 발견할 수 있었던 시간',
    content: '이번 서버심화 스터디를 진행하면서 다른 스터디에선 찾을 수 없는 spring의 로우레벨을 학습할 수 있었다는 게 너무 좋았다. 특히, 서블릿과 트랙잭션 파트를 통해 spring의 동작과정을 더욱 명확히 알 수 있었고, 이를 통해 멋 모르고 개발하기 보단 구조적으로 생각하며 개발을 할 수 있게 되었다. 스스로 생각해보며 바이브 코딩 단계를 벗어나 자신의 잠재능력을 향상시킬 수 있는 계기가 된 좋은 스터디 시간이었다.',
    name: '익명',
    department: 'Backend Developer',
    isLeft: true,
    cohort: '4기',
  },
];
